<script setup>
import { ref, computed, onMounted, watch, } from 'vue'
import { gApp,  } from '../State.js'
import { removeElem } from '../SharedUtils.js'
import SimpleCollapse from './SimpleCollapse.vue'
import InputGroup from './InputGroup.vue'
import HouseUserGuide from './HouseUserGuide.vue'
import BasicModal from './utils/BasicModal.vue'

let proj = computed(() => {
  return gApp.proj();
})

const welcomeModalRef = ref(null);

const handleWelcomeModalDone = () => {
  // Could store a flag in localStorage to not show again for this project
  console.log("Welcome modal closed");
};

onMounted(() => {
  let proj = gApp.proj();
  if (proj && !proj.hasShownWelcomeMessage()) {
    console.log("Showing welcome modal");
    welcomeModalRef.value.showModal();
    proj.setShownWelcomeMessage();
  }
})

</script>

<template>
  <div class="Container">
    <BasicModal 
      ref="welcomeModalRef"
      :showCancel="false"
      doneText="Start"
      @onDone="handleWelcomeModalDone"
      :extraClasses="{'centered-footer': true, 'welcome-modal': true}"
    >
      <div class="welcome-content">
        <p>
          <h2 class="welcome-heading pc">Welcome to your new project.</h2>
        </p>
        <p class="f-l">
          Follow the <b>Project Guide</b> below to calculate loads.
        </p>
      </div>
    </BasicModal>
    
    <HouseUserGuide class="mb-l" />
  </div>
</template>

<style scoped>

.LastSection {
  margin-bottom: var(--space-xl);
}

.WallsTable td {
  vertical-align: top;
}

.UsersTable {
  border: 1px solid var(--b-20);
  min-width: 600px;
}

.ShareBtn {
  padding: var(--space-xxs);
  /* margin-left: auto; */
}

.SharingRemoveBtn {
  margin-left: auto;
}

.MainHelp {
  width: 520px;
}

.welcome-content {
  text-align: left;
  padding: var(--space-xs);
}

.welcome-heading {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.welcome-content p {
  margin-bottom: var(--space-m);
  line-height: 1.5;
}

.welcome-steps {
  margin: var(--space-m) 0;
  padding-left: var(--space-l);
}

.welcome-steps li {
  margin-bottom: var(--space-s);
  line-height: 1.5;
}

</style>
